module.exports = __webpack_public_path__ + "static/assets/be58cb78b0cff210e1ffd1907d9d0890.gif";